export const cibBuysellads = ["32 32","<path d='M16 9.419l2.681 10.044h-5.362zM30 5v22c0 1.656-1.344 3-3 3h-22c-1.656 0-3-1.344-3-3v-22c0-1.656 1.344-3 3-3h22c1.656 0 3 1.344 3 3zM25.919 25.331l-5.906-18.669h-8.025l-5.906 18.669h5.669l6.981-5.725 1.512 5.725z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-buysellads.js
// module id = null
// module chunks = 